import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar"
import type { SidebarIcon } from "@/components/sidebar/sidebar-icon-registry"
import { SidebarGlyphSlot } from "@/components/sidebar/sidebar-glyph-slot"
import { cn } from "@/lib/utils"
import type { SidebarMenuSelectedStyle } from "@/types/theme"

interface SidebarNavItemProps {
  icon: SidebarIcon
  label: string
  onClick: () => void
  tooltip?: string
  disabled?: boolean
  menuLayout: "horizontal" | "vertical"
  isCollapsed?: boolean
  path?: string
  isActive?: boolean
  selectedStyle?: SidebarMenuSelectedStyle | string | null
  className?: string
}

export function SidebarNavItem({
  icon: Icon,
  label,
  onClick,
  tooltip,
  disabled = false,
  menuLayout,
  isCollapsed = false,
  path: _path, // used by parent for isActive computation
  isActive = false,
  selectedStyle,
  className,
}: SidebarNavItemProps) {
  return (
    <SidebarMenuItem className={className}>
      <SidebarMenuButton
        menuLayout={menuLayout}
        tooltip={isCollapsed ? (tooltip ?? label) : undefined}
        onClick={onClick}
        disabled={disabled}
        isActive={isActive}
        selectedStyle={selectedStyle}
        className="[&>span:last-child]:overflow-visible [&>span:last-child]:whitespace-nowrap [&>span:last-child]:text-clip"
      >
        <SidebarGlyphSlot>
          <Icon className={cn("size-4 shrink-0", menuLayout === "horizontal" && "text-sidebar-foreground")} />
        </SidebarGlyphSlot>
        {!isCollapsed && (
          <span className="min-w-0 whitespace-nowrap">
            {label}
          </span>
        )}
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
